import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import FormContainer from '../../common/FormContainer';
import CrossButton from '../../common/CloseButton/CrossButton';

const fadeIn = keyframes`
  from {
    transform: translateX(198px);
    opacity: 0;
  }
  to {
    transform: translateX(0px);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    transform: translateX(0px);
    opacity: 1;
  }
  to {
    transform: translateX(198px);
    opacity: 0;
  }
`;

class PopupForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isClosed: false,
        };

        this.closeMenu = this.closeMenu.bind(this);
        this.onAnimationEnd = this.onAnimationEnd.bind(this);
    }

    onAnimationEnd() {
        const { isClosed } = this.state;

        if (isClosed === true) {
            const { handleClosePopUp } = this.props;
            handleClosePopUp();
        }
    }

    closeMenu() {
        this.setState({ isClosed: true });
        this.onAnimationEnd();
    }

    render() {
        const { className, checkboxes, scrollToForm } = this.props;
        const { isClosed } = this.state;

        return (
            <Root className={className}>
                <BlurWrapper onClick={this.closeMenu} />
                <FormWrapper onAnimationEnd={this.onAnimationEnd} isClosed={isClosed}>
                    <CrossButtonStyled onClick={this.closeMenu} />
                    <FormContainerStyled checkboxes={checkboxes} delay="0" translateY="0" scrollTo={scrollToForm} />
                </FormWrapper>
            </Root>
        );
    }
}

const Root = styled.div`
    display: flex;
    width: 100%;
    height: 100%;

    position: relative;
`;

const FormWrapper = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    overflow-y: scroll;

    background: #FFFFFF;

    animation-delay: 0s;
    animation-name: ${({ isClosed }) => (!isClosed ? fadeIn : fadeOut)};
    animation-duration: 0.25s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;

    ${mediaWidth.m} {
        min-width: 474px;

        margin-left: auto;
    }

    ${mediaWidth.l} {
        min-width: 598px;
    }

    ${mediaWidth.xl} {
        min-width: 598px;
        width: 598px;
    }
`;

const BlurWrapper = styled.div`
    width: 0px;

    ${mediaWidth.m} {
        width: 100%;
    }
`;

const FormContainerStyled = styled(FormContainer)`
    max-width: 328px;
    height: 100%;

    /* margin-top: 236px;
    padding-bottom: 220px; */

    ${mediaWidth.m} {
        max-width: 348px;

        /* margin-top: 0px;
        padding-bottom: 0px; */
    }

    ${mediaWidth.l} {
        max-width: 359px;

        /* margin-top: 236px;
        padding-bottom: 220px; */
    }

    ${mediaWidth.xl} {
        max-width: 405px;
        min-width: 405px;
/* 
        margin-top: 106px;
        padding-bottom: 50px; */
    }
`;

const CrossButtonStyled = styled(CrossButton)`
    position: absolute;
    top: 16px;
    right: 16px;

    ${mediaWidth.l} {
        top: 24px;
        right: 24px;
    }
`;

export default PopupForm;
